// import axios from '../plugins/axios'
const state = {
  add_item_modal : false,
  edit_item_modal: false,
  id: null,
  is_view_mode: false,
  last_add_item_id: null,
  is_cancel:false,
}
const getters = {
  getDataByKey: (state) => (key) => {
    return state[key]
  }
}
const  actions = {

}
const mutations = {
  setItemData(state,data){
    state[data.key] = data.value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}